import React, { useEffect } from "react";
import styled from "styled-components";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "About US | BP11 ArtPrints";
  }, []);
  return (
    <Container>
      <div className="title">
        <h1>Welcome to BP11 Art Prints!</h1>
        <p>Where art comes to life on canvas.</p>
      </div>
      <p>
        At BP11 Art Prints, we believe that every space deserves to be adorned
        with beauty and personality. That’s why we’re passionate about
        transforming your favorite images into stunning, high-quality prints on
        canvas. Whether it’s a cherished family photo, a breathtaking landscape,
        or a piece of art that speaks to your soul, we’re here to bring your
        vision to life.
      </p>
      <p>
        Our journey began with a simple idea: to make it easy for everyone to
        turn their memories and inspirations into tangible works of art. What
        started as a small passion project has grown into a thriving business,
        driven by our commitment to exceptional quality, outstanding customer
        service, and a love for creativity in all its forms.
      </p>
      <p>
        What sets us apart is our dedication to craftsmanship. Each canvas print
        is meticulously crafted using state-of-the-art printing technology and
        premium materials to ensure vibrant colors, sharp details, and
        long-lasting durability. Whether you choose a traditional canvas wrap, a
        sleek metal print, or a modern acrylic mount, you can trust that your
        artwork will be of the highest quality, ready to be enjoyed for years to
        come.
      </p>
      <p>
        But beyond the products, it’s our commitment to our customers that truly
        defines who we are. We understand that choosing the perfect artwork for
        your space can be a personal and meaningful experience, which is why
        we’re here to guide you every step of the way. From helping you select
        the right size and style to providing expert advice on image resolution
        and composition, our team is dedicated to making your vision a reality.
      </p>
      <p>
        At BP11 Art Prints, we’re not just selling prints – we’re helping you
        create moments, memories, and connections that last a lifetime. We’re
        honored to be a part of your journey, and we can’t wait to see the
        beauty that we’ll create together.
      </p>
      <p>
        Thank you for choosing BP11 Art Prints for all your canvas printing
        needs. Let’s turn your imagination into art.
      </p>
      <br />
      <span>
        <p>Sincerely,</p>
        <p>Emri i pronarit</p>
        <p>Founder, BP11 Art Prints</p>
      </span>
    </Container>
  );
};
const Container = styled.div`
  padding: 7em 7%;
  background-color: var(--primaryBackgroundColor);
  color: var(--fontPrimaryColor);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 2em;
  p {
    max-width: 1000px;
  }
  .title {
    font-size: 2em;
    p {
      font-size: 20px;
    }
  }
  span {
    align-self: flex-start;
    text-align: start;
    margin-left: 7%;
    p {
      color: var(--fontSecondaryColor);
    }
  }
  @media (max-width: 600px) {
    .title {
      h1 {
        font-size: 1em;
      }
      p {
        font-size: 17px;
        color: var(--fontSecondaryColor);
      }
    }
  }
`;

export default AboutUs;
